import store from '@/store';
import router from '@/router';
import axios from 'axios';

const instance = axios.create({
  baseURL: "https://webportal.wanorn.com/backend/",
  withCredentials: true,
});

instance.interceptors.request.use(
  config => {
    if (store.getters.userToken) {
      config.headers['Authorization'] = `Bearer ${store.getters.userToken}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      store.commit('unauthenticateUser');
      localStorage.removeItem('token');
      localStorage.removeItem('role');

      if (router.currentRoute.value.name !== 'Login') {
        router.push({ name: 'Login' });
      }
    }
    return Promise.reject(error);
  }
);

export default instance;